module.exports = "<!-- ko if: type === \"img\" -->\r\n<img data-bind=\"attr:{src:url}\"/>\r\n<!-- /ko -->\r\n<!-- ko if: type === \"text\" -->\r\n<span data-bind=\"style.backgroundColor: color\" class=\"avatar-{{size}}\">{{name}}</span>\r\n<!-- /ko -->\r\n<!-- ko if: type === \"icon\" -->\r\n<i data-bind=\"style.backgroundColor: color\" class=\"iconfont avatar-{{size}}\">{{name}}</i>\r\n<!-- /ko -->\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/template/Avatar.html
// module id = 88
// module chunks = 0